import React from "react";

import { useUserState } from "api/lib";
import { Waypoints, Wrench } from "lucide-react";

import { MenuLink } from "./menu-link";

export type MenuProjectProps = {
  projectId: string;
};

export const MenuProject = ({ projectId }: MenuProjectProps) => {
  const { features } = useUserState();

  return !features?.sandbox_access ? (
    <>
      <MenuLink url={`/projects/${projectId}`} title="Scenarios" testLabel={"scenarios"} end={true}>
        <Waypoints size="lg" />
      </MenuLink>
      <MenuLink url={`/projects/${projectId}/settings`} title="Project Settings" testLabel={"project-settings"}>
        <Wrench size="lg" />
      </MenuLink>
    </>
  ) : (
    <></>
  );
};
